import { TextField } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import ImageUploader from '../../../elementsHTML/ImageUploader';

const useStyles = makeStyles({
  textfield: {
    marginTop: '5%',
    marginBottom: '5%',
  },
  imageUploader: {
    flexDirection: 'row',
    justifyContent: 'flex-start !important',
    marginTop: '5%',
    marginBottom: '5%',
    '& > div': {
      marginRight: '5%'
    }
  },
  formWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  formcontrol: {
    display: 'flex',
    marginBottom: '5%',
    '& label': {
      width: '50%',
      fontSize: '0.9em'
    },
    '&.multiline': {
      display: 'flex',
      flexDirection: 'column',
      '& label': {
        width: '100%'
      }
    }
  },
  imageComponent: {
    height: '40px',
    width: 'auto',
    marginRight: '2%'
  }
});

const MainConfigComponent = (props: any) => {
  const { t } = useTranslation('common');
  const classes = useStyles();
  return (
    <div className={classes.formWrapper}>
      <TextField
        id="name"
        className={classes.textfield}
        label={t('Name')}
        variant="outlined"
        value={props.item.name}
        onChange={(e) => {
          props.item.name = e.target.value;
          props.setObjectData(props.item);
        }}
      />

      <div className={classes.formcontrol + ' multiline'}>
        <label id="progressionImage-label">Title</label>
        <TextField
          id="url"
          className={classes.textfield}
          label=''
          variant="outlined"
          value={props.item.title ? props.item.title : ''}
          onChange={(e) => {
            props.item.title = e.target.value;
            props.setObjectData(props.item);
          }}
        />
      </div>

      <div className={classes.formcontrol + ' multiline'}>
        <label id="progressionImage-label">Description</label>
        <TextField
          id="url"
          className={classes.textfield}
          label=''
          variant="outlined"
          value={props.item.description ? props.item.description : ''}
          onChange={(e) => {
            props.item.description = e.target.value;
            props.setObjectData(props.item);
          }}
        />
      </div>

      <div className={classes.formcontrol + ' multiline'}>
        <label id="progressionImage-label">URL</label>
        <TextField
          id="url"
          className={classes.textfield}
          label=''
          variant="outlined"
          value={props.item.url ? props.item.url : ''}
          onChange={(e) => {
            props.item.url = e.target.value;
            props.setObjectData(props.item);
          }}
        />
      </div>
      <div className={classes.formcontrol + ' multiline'}>
        <label id="progressionImage-label">Thumbnails Image</label>
        <ImageUploader
          title=''
          className={classes.imageUploader}
          style={{ flexDirection: 'row' }}
          image={props.item.imageHomepage ? props.item.imageHomepage : ''}
          imageRatio={1}
          callback={(fileKey: any) => {
            if (fileKey) {
              props.item.imageHomepage = fileKey;
              props.setObjectData(props.item);
            }
          }}
        />
      </div>      <div className={classes.formcontrol + ' multiline'}>
        <label id="progressionImage-label">Phone Thumbnail Image</label>
        <ImageUploader
          title=''
          className={classes.imageUploader}
          style={{ flexDirection: 'row' }}
          image={props.item.imagePhoneHomepage ? props.item.imagePhoneHomepage : ''}
          imageRatio={1}
          callback={(fileKey: any) => {
            if (fileKey) {
              props.item.imagePhoneHomepage = fileKey;
              props.setObjectData(props.item);
            }
          }}
        />
      </div>

      <div className={classes.formcontrol + ' multiline'}>
        <label id="progressionImage-label">Icon</label>
        <ImageUploader
          title=''
          className={classes.imageUploader}
          style={{ flexDirection: 'row' }}
          image={props.item.icon ? props.item.icon : ''}
          imageRatio={1}
          callback={(fileKey: any) => {
            if (fileKey) {
              props.item.icon = fileKey;
              props.setObjectData(props.item);
            }
          }}
        />
      </div>
      <div className={classes.formcontrol + ' multiline'}>
        <label id="progressionImage-label">Publication Date</label>
        <TextField
          id="publicationDate"
          type="date"
          className={classes.textfield}
          label=''
          variant="outlined"
          value={props.item.publicationDate ? props.item.publicationDate : ''}
          InputLabelProps={{
            shrink: true,
          }}
          onChange={(e) => {
            props.item.publicationDate = e.target.value;
            props.setObjectData(props.item);
          }}
        />
      </div>
    </div>
  );
};

export default function LibraryMainConfig(props: any) {
  return (
    <div >
      <MainConfigComponent {...props} />
    </div>
  );
}
